<template>
    <div>
        <b-row class="my-2 align-items-center">
            <b-col cols="12" md="6" class="mb-2 mb-md-0">
                <b-input-group size="sm">
                    <b-form-input
                            v-model="filter"
                            debounce="200"
                            type="search"
                            id="filterInput"
                            placeholder="Введите для поиска"
                    ></b-form-input>
                    <b-input-group-append>
                        <b-form-select v-model="reportStatus" :options="reportStatusOptions"></b-form-select>
                        <b-form-select
                                v-model="archiveOnly"
                                :options="archiveScopeOptions"
                                aria-label="Статус объекта"
                        ></b-form-select>
                    </b-input-group-append>
                </b-input-group>
            </b-col>
            <b-col cols="12" md="6">
                <div class="d-flex flex-wrap justify-content-md-end align-items-center">
                    <span class="text-success small mr-2 mb-2 mb-md-0">Найдено записей: {{ totalRows }}</span>
                    <b-pagination
                            v-model="currentPage"
                            :total-rows="totalRows"
                            :per-page="perPage"
                            align="fill"
                            size="sm"
                            class="my-0 mb-2 mb-md-0 mr-2"
                    ></b-pagination>
                    <div class="mb-2 mb-md-0">
                        <b-form-group
                                label="На странице"
                                label-cols="6"
                                label-size="sm"
                                label-for="perPageSelect"
                                class="mb-0 d-flex align-items-center"
                        >
                            <b-form-select
                                    v-model="perPage"
                                    id="perPageSelect"
                                    size="sm"
                                    :options="pageOptions"
                            ></b-form-select>
                        </b-form-group>
                    </div>
                </div>
            </b-col>
        </b-row>
        <b-table
                responsive="sm"
                :fields="fields"
                :filter="filter"
                small
                striped
                :items="items"
                :current-page="currentPage"
                :per-page="perPage"
                @filtered="onFiltered"
                :busy="isBusy"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                sticky-header="80vh"
                :tbody-tr-class="reportRowClass"
        >
            <template #cell(report_status)="data">
                <b-badge
                        v-if="isAnnulled(data.item)"
                        variant="danger"
                        :title="data.item.shift && data.item.shift.annulment_reason || ''"
                >
                    АННУЛИРОВАН — НЕ УЧИТЫВАТЬ
                </b-badge>
                <b-badge v-else variant="success">Действующий</b-badge>
            </template>
            <template v-slot:cell(availablePercents)="data">
                {{ data.item.availablePercents }}%
            </template>
            <template v-slot:cell(fact.percents)="data">
                {{ data.item.fact.percents }}%
            </template>
            <template v-slot:cell(limitError)="data">
                <b-form-checkbox
                        :id="`trigger-${data.index}`"
                        :checked="data.item.limitError"
                        disabled
                >
                </b-form-checkbox>
            </template>
            <template #table-busy>
                <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle mx-2"></b-spinner>
                    <strong>Загрузка данных...</strong>
                </div>
            </template>
        </b-table>
    </div>
</template>

<script>
    export default {
        computed: {
            items() {
                const rows = this.$store.state.materials.usage || [];
                if (this.reportStatus === `active`) return rows.filter(row => !this.isAnnulled(row));
                if (this.reportStatus === `annulled`) return rows.filter(row => this.isAnnulled(row));
                return rows;
            }
        },
        data() {
            return {
                fields: [
                    {key: `report_status`, label: `Статус отчёта`},
                    {
                        key: `shift.id`,
                        label: `Смена`,
                        sortable: true
                    },
                    {
                        key: `shift.begin`,
                        label: `Начало смены`,
                        sortable: true
                    },
                    {
                        key: `object.name`,
                        label: `Объект`,
                        sortable: true
                    },
                    {
                        key: `work.name`,
                        label: `Работа`,
                        sortable: true
                    },
                    {
                        key: `work.measures`,
                        label: `ЕИ раб.`
                    },
                    {
                        key: `material.name`,
                        label: `Материал`,
                        sortable: true
                    },
                    {
                        key: `material.measures`,
                        label: `ЕИ мат.`
                    },
                    {
                        key: `targets.work`,
                        label: `Объем работ по договору`
                    },
                    {
                        key: `targets.material`,
                        label: `Объем материала по договору`
                    },
                    {
                        key: `completed.work`,
                        label: `Выполнено работ за смену`
                    },
                    {
                        key: `completed.material`,
                        label: `Затрачено материала за смену`
                    },
                    {
                        key: `plans.summary`,
                        label: `Планируемые затраты материала (без учёта отклонений прошлых смен)`
                    },
                    {
                        key: `deviation.perMeasures`,
                        label: `Отклонение в ЕИ мат.`
                    },
                    {
                        key: `summary.work`,
                        label: `Накоп. итог РАБОТА`
                    },
                    {
                        key: `summary.material`,
                        label: `Накоп. итог МАТЕРИАЛ`
                    },
                    {
                        key: `plans.perMeasures`,
                        label: `Планируемый расход (на ЕИ)`
                    },
                    {
                        key: `fact.value`,
                        label: `Реальный расход (на ЕИ)`
                    },
                    {
                        key: `availablePercents`,
                        label: `Граница тревоги (%)`
                    },
                    {
                        key: `fact.percents`,
                        label: `Фактическая погрешность (%)`
                    },
                    {
                        key: `limitError`,
                        label: `Срабатывание тревоги`,
                        sortable: true
                    }
                ],
                filter: null,
                filterOn: [],
                perPage: 100,
                pageOptions: [5, 10, 15, 20, 100, 200],
                totalRows: 1,
                currentPage: 1,
                isBusy: true,
                sortBy: 'shift.begin', // ключ поля
                sortDesc: true,        // true — сперва последние (по дате)
                archiveOnly: false,
                archiveScopeOptions: [
                    {value: false, text: `Действующие объекты`},
                    {value: true, text: `Архив объектов`}
                ],
                reportStatus: `all`,
                reportStatusOptions: [
                    {value: `all`, text: `Все отчёты`},
                    {value: `active`, text: `Действующие`},
                    {value: `annulled`, text: `Аннулированные`}
                ]
            }
        },
        async mounted() {
            await this.loadMaterialUsage();
        },
        methods: {
            async loadMaterialUsage() {
                this.isBusy = true;
                try {
                    await this.$store.dispatch(`getMaterialUsage`, this.archiveOnly);
                    await this.$nextTick();
                    this.totalRows = this.items.length;
                    this.currentPage = 1;
                } finally {
                    this.isBusy = false;
                }
            },
            onFiltered(filteredItems) {
                this.totalRows = filteredItems.length;
                this.currentPage = 1;
            },
            isAnnulled(item) {
                return Boolean(item && (item.isAnnulled || (item.shift && item.shift.annulled_at)));
            },
            reportRowClass(item) {
                return this.isAnnulled(item) ? `legacy-report-row--annulled` : ``;
            }
        },
        watch: {
            archiveOnly() {
                this.loadMaterialUsage();
            },
            reportStatus() {
                this.$nextTick(() => {
                    this.totalRows = this.items.length;
                    this.currentPage = 1;
                });
            }
        },
        name: "MaterialUsing"
    }
</script>

<style scoped>
    table {
        font-size: 12px;
    }

    >>> tr.legacy-report-row--annulled > td {
        background: #fff3f3;
        color: #721c24;
    }

</style>
